import { type ClassValue, clsxm } from '@vs-shop/utils';
import { cva } from 'class-variance-authority';
import { Check, X } from 'lucide-react';

const checkOrCrossVariants = cva('size-5 shrink-0', {
  variants: {
    state: {
      check: 'text-success stroke-2',
      cross: 'text-foreground-muted stroke-1',
    },
  },
});

export type CheckOrCrossProps = {
  value: boolean;
  classNameCheck?: ClassValue;
  classNameCross?: ClassValue;
};

export function CheckOrCross({ value, classNameCheck, classNameCross }: CheckOrCrossProps) {
  return value ? (
    <Check
      data-slot="check-or-cross"
      className={clsxm(checkOrCrossVariants({ state: 'check' }), classNameCheck)}
    />
  ) : (
    <X
      data-slot="check-or-cross"
      className={clsxm(checkOrCrossVariants({ state: 'cross' }), classNameCross)}
    />
  );
}

export { checkOrCrossVariants };
